module.exports = __webpack_public_path__ + "img/upload.aa80ceca0fe78a0b85cc71f13dbf5ac7.aa80ceca.png";